export default __webpack_public_path__ + "waiting-approval.fb3b7ac55ce3a6cd.svg";